import { cn } from '@/lib/utils';

/**
 * Preset "spotlight" (fondo brand-dark): grilla de 48px con máscara radial,
 * un spotlight violeta que sigue al mouse (--mx/--my) y tres beams verticales
 * que caen en loop. El título que lo acompaña usa `pl-shimmer`.
 */
export function SpotlightBackground({ mood = 'calm', className }: { mood?: 'calm' | 'bold'; className?: string }) {
  const bold = mood === 'bold';
  return (
    <div className={cn('absolute inset-0 overflow-hidden bg-brand-dark', className)} aria-hidden>
      <div
        className="absolute inset-0 opacity-[0.35]"
        style={{
          backgroundImage:
            'linear-gradient(to right, rgba(255,255,255,.08) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,.08) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
          maskImage: 'radial-gradient(ellipse 70% 70% at 50% 40%, #000 30%, transparent 100%)',
          WebkitMaskImage: 'radial-gradient(ellipse 70% 70% at 50% 40%, #000 30%, transparent 100%)',
        }}
      />
      <div
        className="absolute h-[60vw] w-[60vw] rounded-full blur-[70px] pl-follow"
        style={{
          left: 'calc(var(--mx, .35) * 100% - 30vw)',
          top: 'calc(var(--my, .4) * 100% - 30vw)',
          background: 'radial-gradient(closest-side, rgba(206,171,255,.55), rgba(206,171,255,0))',
          opacity: bold ? 0.9 : 0.65,
        }}
      />
      {[
        { left: '18%', delay: '0s', color: '#1CC9B9' },
        { left: '52%', delay: '2.4s', color: '#CEABFF' },
        { left: '81%', delay: '4.8s', color: '#87DBFF' },
      ].map((b) => (
        <span
          key={b.left}
          className={cn('absolute top-0 h-40 w-px pl-beam', bold && 'pl-bold')}
          style={{
            left: b.left,
            animationDelay: b.delay,
            background: `linear-gradient(to bottom, transparent, ${b.color}, transparent)`,
          }}
        />
      ))}
      <div className="absolute inset-0 bg-linear-to-b from-transparent to-brand-dark/70" />
    </div>
  );
}
